/* eslint-disable no-use-before-define */
import React from 'react'
import { Flyout } from '../../twd'
import GridRow from './grid-row'


export default ({rows, dataCategory='quick-ideas', dataName='overview-quick-ideas', showFrequency=false} = {}) => (
    <React.Fragment>
    <div className="table-responsive">
    <table
        data-module='overview-quick-ideas'
        data-category={dataCategory}
        data-name={dataName + '-table'}
        className="table">
    <thead>
        <tr>
        <th className="col-md-6">Issuer</th>
        <th className="col-md-2">Maturity</th>
        <th style={{ 'whiteSpace':'nowrap' }} className="col-md-1">
            <Flyout label="Yield" html={DISCLAIMER}/>
        </th>
        { showFrequency
            ? (<th className="text-right col-md-2" style={{whiteSpace:'nowrap'}}>Coupon Frequency</th>)
            : (<th className="text-right col-md-2">Moody's / S&amp;P</th>)
        }
        <th className="text-right col-md-1">Price</th>
        </tr>
    </thead>
    <tbody>
        { Array.isArray(rows) && rows.map((a, i) => (
            <GridRow dataCategory={dataCategory} dataName={dataName} key={i} data={a} index={i} showFrequency={showFrequency} />
        )) }
    </tbody>
    </table>
    </div>
    </React.Fragment>
)


let DISCLAIMER=`
    The yield to worst metric is used to evaluate
    the lowest (worst-case scenario) yield an investor could experience – with
    the assumption the issuer does not default. Select your range for yield to worst.
    `
